module.exports = __webpack_public_path__ + "img/mine_pa.7c7f4e5b.png";